// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './index.vue'
import '../../assets/css/reset.css'
import '../../assets/css/animate.css'
import "../../assets/js/jquery.singlePageNav.min.js"

Vue.use(ElementUI);

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/pages/index/index.js